<template>
  <Dialog v-model:visible="showDialogEditManager" :style="{width: '50vw'}" position="top"
          :closable="false" :draggable="false" :modal="true">
    <template #header>
      <h2>{{ $t('common.dialogEditManager.title') }}</h2>
    </template>
    <div class="col-12 grid">
      <div><p>{{ $t('common.dialogEditManager.body') }}</p></div>
      <div v-if="loading">
        <ProgressSpinner style="height: 2em;margin: 0 0 0 -2em;padding-top: 0.5em" strokeWidth="2" />
      </div>
    </div>
    <template #footer>
      <Button :label="$t('common.dialogEditManager.buttonAnnulla')" icon="pi pi-times" class="p-button-secondary"
              :disabled="loading" @click="closeDialogEditManager()" />
      <Button :label="$t('common.dialogEditManager.buttonComeBack')" icon="pi pi-external-link"
              class="p-button-secondary"
              :disabled="loading" @click="comeBackToEdit()" />
    </template>
  </Dialog>
  <div :class="containerClass" @click="onDocumentClick" style="height: 101vh">
    <Toast />

    <AppTopBar :topbarMenuActive="topbarMenuActive" :activeTopbarItem="activeTopbarItem"
               :horizontal="isHorizontal()" :profileMode="profileMode" :periods="periods"
               @menubutton-click="onMenuButtonClick" @topbar-menubutton-click="onTopbarMenuButtonClick"
               @topbar-item-click="onTopbarItemClick" />
    <div class="layout-menu-container" @click="onMenuClick">

      <div class="layout-menu-wrapper">
        <div class="menu-scroll-content">
          <AppMenu :model="grouped ? menuGrouped : menuUngrouped" :layoutMode="layoutMode"
                   :active="menuActive" @menuitem-click="onMenuItemClick"
                   @root-menuitem-click="onRootMenuItemClick"></AppMenu>
        </div>
      </div>
    </div>

    <div class="layout-main">
      <AppBreadcrumb></AppBreadcrumb>
      <div class="layout-content">
        <router-view />
      </div>
      <AppFooter />
    </div>


    <div v-if="staticMenuMobileActive" class="layout-mask"></div>
  </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppBreadcrumb from './AppBreadcrumb.vue';
import AppFooter from './AppFooter.vue';
import EventBus from './event-bus';
import LoginService from './service/LoginService';
import { isEmpty } from '@/main';
import AnalysisService from '@/service/AnalysisService';
import { logout as keycloakLogout } from '@/service/KeycloakService';

export default {
  components: {
    'AppTopBar': AppTopBar,
    'AppMenu': AppMenu,
    'AppBreadcrumb': AppBreadcrumb,
    'AppFooter': AppFooter,
  },
  created() {
    this.loginService = new LoginService();
    this.analysisService = new AnalysisService();
  },
  beforeMount() {
    this.loadPortfolioTypes();
  },
  data() {
    return {
      layoutMode: 'slim',
      staticMenuDesktopInactive: false,
      staticMenuMobileActive: false,
      overlayMenuActive: false,
      topbarMenuActive: false,
      activeTopbarItem: null,
      menuActive: false,
      darkMenu: true,
      profileMode: 'inline',
      grouped: true,
      periods: [],
      token: null,
    };
  },
  computed: {
    menuGrouped() {
      return this.$store.getters['acl/appMenu'];
    },
    menuUngrouped() {
      return [
        {
          label: 'Main Menu',
          icon: 'pi pi-fw pi-home',
          items: this.menuGrouped,
        },
      ];
    },
    editing() {
      return this.$store.getters['editing'];
    },
    showDialogEditManager() {
      return this.$store.getters['showDialogEditManager'];
    },
    fromRoute() {
      return this.$store.getters['fromRoute'];
    },
    containerClass() {
      return [ 'layout-wrapper', {
        'layout-horizontal': this.layoutMode === 'horizontal',
        'layout-overlay': this.layoutMode === 'overlay',
        'layout-static': this.layoutMode === 'static',
        'layout-slim': this.layoutMode === 'slim',
        'layout-static-inactive': this.staticMenuDesktopInactive,
        'layout-mobile-active': this.staticMenuMobileActive,
        'layout-overlay-active': this.overlayMenuActive,
        'layout-menu-dark': this.darkMenu,
        'layout-menu-light': !this.darkMenu,
        'p-input-filled': this.$appState.inputStyle === 'filled',
        'p-ripple-disabled': this.$primevue.config.ripple === false,
      } ];
    },
    loading() {
      return this.$store.state.loading > 0;
    },
    portfolioList() {
      return this.$store.state.user.portfolioList;
    },
    user() {
      return this.$store.state.user;
    },
    role() {
      return this.user != null ? this.user.role : null;
    },
    selectedPortfolio() {
      return this.$store.state.selectedPortfolio;
    },
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
    user: {
      handler() {
        this.loadPeriods();
      },
      immediate: true,
    },
    /*
    selectedPortfolio() {
      if (this.user.role === 'selectiodir' && this.selectedPortfolio.sftpPortfolioAnalysisExport === true) {
        let menu = this.$methods.deepClone(this.menuGrouped)
        let indexOf = menu.indexOf(menu.find(element => element.label === 'Admin'))
        menu[indexOf].items =
            [{label: this.$t("manageportfolio.label"), icon: 'fa fa-fw fa-archive', to: '/manage_portfolio'},
              {
                label: this.$t("manageiconportfolios.label"),
                icon: 'fa fa-fw fa-archive',
                to: '/manage_icon_portfolios'
              },
              {label: this.$t('gestioneacquisti.label'), icon: 'fa fa-fw fa-archive', to: '/gestione_acquisti'},
              {
                label: this.$t('portfolio.apiBusinessInformation'),
                icon: 'fa fa-fw fa-archive',
                to: '/manage_api_contracts'
              },
              {label: this.$t('menu.statistics'), icon: 'pi pi-chart-line', to: '/statistics'},
              {label: this.$t('menu.SFTP'), icon: 'pi pi-folder-open', to: '/SFTP'}]
        this.$store.commit("acl/setAppMenu", menu)
      } else if (this.user.role === 'selectiodir' && this.selectedPortfolio.sftpPortfolioAnalysisExport !== true) {
        let menu = this.$methods.deepClone(this.menuGrouped)
        let indexOf = menu.indexOf(menu.find(element => element.label === 'Admin'))
        menu[indexOf].items =
            [{label: this.$t("manageportfolio.label"), icon: 'fa fa-fw fa-archive', to: '/manage_portfolio'},
              {
                label: this.$t("manageiconportfolios.label"),
                icon: 'fa fa-fw fa-archive',
                to: '/manage_icon_portfolios'
              },
              {label: this.$t('gestioneacquisti.label'), icon: 'fa fa-fw fa-archive', to: '/gestione_acquisti'},
              {
                label: this.$t('portfolio.apiBusinessInformation'),
                icon: 'fa fa-fw fa-archive',
                to: '/manage_api_contracts'
              },
              {label: this.$t('menu.statistics'), icon: 'pi pi-chart-line', to: '/statistics'}]
        this.$store.commit("acl/setAppMenu", menu)
      }
    }
     */
  },
  methods: {
    async comeBackToEdit() {
      await this.$router.push({ path: this.fromRoute });
      this.$store.commit('setShowDialogEditManager', false);
    },
    closeDialogEditManager() {
      if (this.selectedPortfolio != null && this.selectedPortfolio.id < 0) {
        this.$store.state.user.portfolioList = this.$store.state.user.portfolioList.filter(p => p.id > 0);
        this.$store.commit('setSelectedPortfolio', null);
      }
      this.$store.commit('setEditing', false);
      this.$store.commit('setShowDialogEditManager', false);
    },
    onDocumentClick() {
      if (!this.topbarItemClick) {
        this.activeTopbarItem = null;
        this.topbarMenuActive = false;
      }

      if (!this.menuClick) {
        if (this.isHorizontal() || this.isSlim()) {
          this.menuActive = false;
        }

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
          this.hideOverlayMenu();
        }

        EventBus.emit('reset-active-index');
        this.unblockBodyScroll();
      }

      this.topbarItemClick = false;
      this.menuClick = false;
    },
    onMenuButtonClick(event) {
      this.menuClick = true;
      this.topbarMenuActive = false;

      if (this.layoutMode === 'overlay') {
        this.overlayMenuActive = !this.overlayMenuActive;
      }

      if (this.isDesktop())
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
      else {
        this.staticMenuMobileActive = !this.staticMenuMobileActive;
        if (this.staticMenuMobileActive) {
          this.blockBodyScroll();
        } else {
          this.unblockBodyScroll();
        }
      }

      event.preventDefault();
    },
    onTopbarMenuButtonClick(event) {
      this.topbarItemClick = true;
      this.topbarMenuActive = !this.topbarMenuActive;
      this.hideOverlayMenu();
      event.preventDefault();
    },
    onTopbarItemClick(event) {
      this.topbarItemClick = true;
      if (event.item === 'signout') {
        this.doLogout();
        return true;
      }

      if (this.activeTopbarItem === event.item)
        this.activeTopbarItem = null;
      else
        this.activeTopbarItem = event.item;

      event.originalEvent.preventDefault();
    },
    onMenuClick() {
      this.menuClick = true;
    },
    isHorizontal() {
      return this.layoutMode === 'horizontal';
    },
    isSlim() {
      return this.layoutMode === 'slim';
    },
    hideOverlayMenu() {
      this.overlayMenuActive = false;
      this.staticMenuMobileActive = false;
    },
    isDesktop() {
      return window.innerWidth > 1219;
    },
    onMenuItemClick(event) {
      if (!event.item.items) {
        EventBus.emit('reset-active-index');
        this.hideOverlayMenu();
      }
      if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
        this.menuActive = false;
      }
    },
    onRootMenuItemClick() {
      this.menuActive = !this.menuActive;
    },
    addClass(element, className) {
      if (element.classList)
        element.classList.add(className);
      else
        element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList)
        element.classList.remove(className);
      else
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    blockBodyScroll() {
      this.addClass(document.body, 'blocked-scroll');
    },
    unblockBodyScroll() {
      this.removeClass(document.body, 'blocked-scroll');
    },
    doLogout() {
      this.$store.dispatch('logout');
      localStorage.removeItem('vuex');
      keycloakLogout();
    },
    loadPeriods() {
      if (!this.analysisService) {
        this.analysisService = new AnalysisService();
      }
      if (this.user != null) {
        if (this.$store.getters.periods != null && this.$store.getters.periods.length > 0) {
          return;
        }
        this.analysisService.getAllPeriods()
            .then(data => {
              if (isEmpty(this.$store.getters.selectedPeriod))
                this.$store.commit('setSelectedPeriod', data[0]);
              if (isEmpty(this.$store.getters.comparedPeriod))
                this.$store.commit('setComparedPeriod', data[1]);
              data.forEach(p => p.id = p.value = p.periodId);
              this.periods = [ ...data ];
              this.$store.commit('setPeriods', data);
            })
            .catch(e => {
              console.error('loadPeriods', e);
            });
      }
    },
    loadPortfolioTypes() {
      let portfolioTypes = [
        {
          value: 'prospect',
          description: this.$t('common.portfolioTypes.prospect'),
        },
        {
          value: 'customer',
          description: this.$t('common.portfolioTypes.customer'),
        },
      ];
      this.$store.commit('setPortfolioTypes', portfolioTypes);
    },
  },
};
</script>

<style lang="scss">
@import 'App.scss';
</style>
